import { Coalmarch } from "./CoalmarchLogo.js";
import { validateTidalLicense } from "../../../base/index.js";
validateTidalLicense();
export {
  Coalmarch
};
//# sourceMappingURL=index.js.map
